import { create } from 'zustand'

// FEATURE 02/07: trava global de EXCLUSÃO.
// Toda ação de excluir no site deve passar por aqui: em vez de chamar o DELETE
// direto (ou um window.confirm), o código chama pedirExclusao({ onConfirm }).
// Isso abre um modal ÚNICO (ModalConfirmarExclusao) que exige a senha de um
// admin/gerente/super_admin (validada em POST /auth/autorizar-exclusao) e só então
// roda o onConfirm (o DELETE de fato). Store zustand p/ poder disparar de qualquer
// lugar, inclusive fora de componente React.

export interface PedidoExclusao {
  /** Título do modal. Default: "Confirmar exclusão". */
  titulo?: string
  /** Descrição do que será excluído (ex.: 'o grupo "Bebidas"'). */
  descricao?: string
  /** Rótulo do botão de confirmação. Default: "Excluir". */
  confirmLabel?: string
  /** Ação de exclusão real, executada só após a senha ser autorizada. */
  onConfirm: () => void | Promise<void>
}

interface ConfirmarExclusaoState {
  pedido: PedidoExclusao | null
  pedir: (p: PedidoExclusao) => void
  fechar: () => void
}

export const useConfirmarExclusao = create<ConfirmarExclusaoState>((set) => ({
  pedido: null,
  pedir: (p) => set({ pedido: p }),
  fechar: () => set({ pedido: null }),
}))

/** Atalho imperativo: abre o modal de confirmação de exclusão. */
export function pedirExclusao(p: PedidoExclusao) {
  useConfirmarExclusao.getState().pedir(p)
}
